import React, { useState } from "react";
import API from "../../../API";
import { ru } from '../../../data/ru';
import { by } from '../../../data/by';
import './sub-information.css'

export default function SubInformationConstructor() {
  let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdOne: by.RoleIdOne;
  const api = new API()
  const [value, setValue] = useState("")

  function changeValue(e) {
    setValue(e.target.value)
  }

  function addSubInformation(v) {
    api.addSubInformationFields(v.split('/'))
  }

  return (
    <>
      <p className='sub-information_text'>{language.AddFieldsToFill}</p>
      <textarea className="sub-information_textarea" value={value} onChange={(e) => changeValue(e)} placeholder={language.enter+"..."}/>
      <button className="sub-information_button" onClick={() => addSubInformation(value)}>{language.buttonAdd}</button>
    </>
  )
}